import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import reorderBackground from "../assets/reorderNumpad.png";

var canSubmitAnswer = true;


export default function Calculator({ currentQuestion, ...props }) {
  const [reverseOrder, setReverseOrder] = useState(false);
  const answer = useRef([]);
  const [displayValue, setDisplayValue] = useState("");
  const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);


  //console.log("calc props");
  //console.log(props);

  useEffect(() => {
    window.addEventListener("keyup", downHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener("keyup", downHandler);
    };
  }, [displayValue]);

  let valueButtons = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  function setTimeOutDisplayValue(){
    //console.log(answer);
    var stringAnswer = answer.current.join("");
    console.log(stringAnswer);
    if (props.onChange != null){
      props.onChange(answer.current.join(""));
    }
  }

  useEffect(() => {
    console.log("cansubmit");
    if (props.cansubmit == true){
      canSubmitAnswer = true;
    }
  }, [props.cansubmit]);

  function submit() {
    console.log(props);
    if (canSubmitAnswer == false){
      return;
    }
    canSubmitAnswer = false;
    console.log(answer);
    var stringAnswer = answer.current.join("");
    console.log(stringAnswer);
    props.onSubmitted(answer.current.join(""), (verdict, value) => {
      return new Promise(function (resolve, reject) {
        if (verdict === false) {
          setShowCorrectAnswer(true);
          setDisplayValue(value);
          setTimeOutDisplayValue();
          setTimeout(function () {
            answer.current = [];
            setDisplayValue(answer.current);
            setTimeOutDisplayValue();
            setShowCorrectAnswer(false);
            return resolve();
          }, 1000);
        } else {
          answer.current = [];
          setDisplayValue(answer.current);
          setTimeOutDisplayValue();
          return resolve();
        }
      });
    });
  }

  function AddNumber(value) {
    if (answer.current.length > 5)
      return;
    answer.current = [...answer.current, value];
    setDisplayValue(answer.current.join(""));
    setTimeOutDisplayValue();
  }

  function downHandler({ key }) {
    if (answer.current.length > 5)
      return;
    switch (key) {
      case "1":
        answer.current = [...answer.current, 1];
        break;
      case "2":
        answer.current = [...answer.current, 2];
        break;
      case "3":
        answer.current = [...answer.current, 3];
        break;
      case "4":
        answer.current = [...answer.current, 4];
        break;
      case "5":
        answer.current = [...answer.current, 5];
        break;
      case "6":
        answer.current = [...answer.current, 6];
        break;
      case "7":
        answer.current = [...answer.current, 7];
        break;
      case "8":
        answer.current = [...answer.current, 8];
        break;
      case "9":
        answer.current = [...answer.current, 9];
        break;
      case "0":
        answer.current = [...answer.current, 0];
        break;
      case "Enter":
        if (answer.current.length > 0 && props.cansubmit) {
          submit();
        }
        break;
      case "Backspace":
        Backspace();
        break;
      default:
        break;
    }
    setDisplayValue(answer.current.join(""));
    setTimeOutDisplayValue();
  }


  function Backspace(){
    if (answer.current.length > 0) {
      answer.current = answer.current.slice(0, -1);
      setDisplayValue(answer.current.join(""));
    }
  }

  return (
    <CalculatorContainer>
      <CalculatorFrame>
        <Question
          textcolor={props.textcolor}
          bgcolor={props.bgcolor}
          textcolor2={props.textcolor2}
          type="text"
          disabled
        >
          {currentQuestion.number1 != undefined ? ( <div>{currentQuestion.number1 + " x " + currentQuestion.number2} = </div>  ): (<div></div> )}
          {
            
           
          }
        </Question>
        {showCorrectAnswer ? (
          <CorrectAnswer textcolor={props.textcolor}
          bgcolor={props.bgcolor}
          textcolor2={props.textcolor2} type="text" disabled value={currentQuestion.answer} />
        ) : (
            <Answer textcolor={props.textcolor}
            bgcolor={props.bgcolor}
            textcolor2={props.textcolor2} type="text" disabled value={displayValue} />
          )}
        <Numberpad>
          {valueButtons.map(value => (
            <CalcButton
            textcolor={props.textcolor}
          bgcolor={props.bgcolor}
          textcolor2={props.textcolor2}
              value={value}
              onClick={() => {
                AddNumber(value)
                //answer.current = [...answer.current, value];
              }}
            >
              {value}
            </CalcButton>
          ))}
          <CalcButton
          textcolor={props.textcolor}
          bgcolor={props.bgcolor}
          textcolor2={props.textcolor2}
            value={0}
            onClick={() => {
              Backspace();
              setTimeOutDisplayValue();
            }}
          >
            &lt;-
          </CalcButton>
          <CalcButton
          textcolor={props.textcolor}
          bgcolor={props.bgcolor}
          textcolor2={props.textcolor2}
            value={0}
            onClick={() => {
              answer.current = [...answer.current, 0];
              setDisplayValue(answer.current.join(""));
              setTimeOutDisplayValue();
            }}
          >
            0
          </CalcButton>
    
          <CalcButton
          textcolor={props.textcolor}
          bgcolor={props.bgcolor}
          textcolor2={props.textcolor2}
            style={ props.cansubmit ? {} : {background: "white", border: "0px"}}
            value={0}
            onClick={() => {
              if (answer.current.length > 0 && props.cansubmit)
              submit();
            }}
          >
            Enter
          </CalcButton>
        </Numberpad>
      </CalculatorFrame>
    </CalculatorContainer>
  );
}

const CalculatorFrame = styled.div`
  width: 500px;
  height: 600px;
  display: flex;
  flex-direction: column;
  //background: rgba(255, 255, 255, 0.7);
  //border-radius: 10px;
  display: relative;
  //border: 2px solid rgb(99, 99, 99);
`;

const CalculatorContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Numberpad = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;

const OrderNumpad = styled.div`
  box-sizing: border-box;
  width: 80px;
  height: 80px;
  border-radius: 40px;
  background-image: url(${reorderBackground});
  background-size: cover;
  margin-left: 30px;
  align-self: center;
  &:hover {
    cursor: pointer;
  }
`;

const Question = styled.div`
  color: ${props => props.textcolor};
  height: 100px;
  line-height: 50px;
  user-select: none;
  font-size: 100px;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  position: relative;
  right: 100%;
  top : 25%;
`;

const Answer = styled.input`
  color: ${props => props.textcolor};
  height: 100px;
  line-height: 50px;
  font-size: 100px;
  margin: 5px 10px;
  text-align: right;
  font-weight: 600;
  border: none;
  background: ${props => props.textcolor2};);
  border: 2px solid ${props => props.textcolor};;
`;

const CorrectAnswer = styled.input`
  height: 70px;
  line-height: 50px;
  font-size: 30px;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  color: green;
`;

const CalcButton = styled.div`
  text-align: center;
  width: 30%;
  height: 70px;
  margin: 5px;
  background:  ${props => props.textcolor};
  border: 2px solid ${props => props.textcolor};
  color: ${props => props.textcolor2};
  user-select: none;
  padding: 0.5em;
  box-sizing: border-box;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const CancelButton = styled.div`
  text-align: center;
  width: 30%;
  height: 70px;
  margin: 5px;
  background: rgb(234, 29, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 29, 19, 1) 0%,
    rgba(255, 60, 50, 1) 100%
  );

  border: 2px solid rgb(234, 29, 19);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const OKButton = styled.div`
  text-align: center;
  width: 30%;
  height: 70px;
  margin: 5px;
  background-color: #999;
  background: rgb(25, 160, 63);
  background: linear-gradient(
    0deg,
    rgba(25, 160, 63, 1) 0%,
    rgba(43, 196, 86, 1) 100%
  );
  border: 2px solid rgb(25, 160, 63);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;
